import React, { useState } from "react";
import FileSaver from "file-saver";
import apiClient from "../GlobalUtilities/BaseUrl/apiClient";
import { Button,CircularProgress } from "@mui/material";

function ExportDataasCSV({ exportEndpoint, buttonTitle = "Export Data",buttonColor="primary",downloadedFileName="ExportedFile.csv" }) {
  const [pageLoader, setPageLoader] = useState(false);

  const handleExportDetails = async () => {
    setPageLoader(true);
    try {
      const response = await apiClient.post(exportEndpoint, {
        userid: "amit",
        responseType: "blob",
      });

      // Trigger file download
      const blob = new Blob([response.data], { type: "text/csv;charset=utf-8;" });
      FileSaver.saveAs(blob, downloadedFileName);
    } catch (error) {
      console.error("Error exporting data:", error);
      alert("Failed to export data. Please try again.");
    }
    setPageLoader(false);
  };

  return (
    <div>
      {pageLoader && (
        <div className="loaderContainer">
          <CircularProgress />
        </div>
      )}
      <Button onClick={handleExportDetails} disabled={pageLoader} variant="contained" color={buttonColor}>
        {buttonTitle}
      </Button>
    </div>
  );
}

export default ExportDataasCSV;
